/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Badge } from '@chakra-ui/react';
import { useMemo } from 'react';
import useStore from '../../store';
import { useDebounceEffect } from '../form/useDebounceEffect';

const QUERY_COUNT_UNREAD_REPORT = gql`
	query {
		getCompanySubmissionReports(pagerInput: { offset: 0, limit: 1 }) {
			countUnreadCompanySubmissionReports
		}
	}
`;

const QUERY_COUNT_UNREAD_STATEMENT = gql`
	query {
		getUnreadEarlyWarningStatementCount
	}
`;

const QUERY_MD_COUNT = gql`
	query {
		getCountUnreadNotifications(openType: "COMPANY_SUBMISSION_MDD_REPORT")
	}
`;

function CompanySubmissionReportBadge() {
	const { countUnreadNotifications } = useStore((state) => state?.countUnreadNotifications);
	const [loadCountUnreadReports, { data: dataUnreadReport }] = useLazyQuery(QUERY_COUNT_UNREAD_REPORT);
	const [loadCountUnreadStatements, { data: dataUnreadStatement }] = useLazyQuery(QUERY_COUNT_UNREAD_STATEMENT);
	const [loadMDCount, { data: dataUnreadMDCount }] = useLazyQuery(QUERY_MD_COUNT);

	useDebounceEffect(load, 200, [countUnreadNotifications]);

	const count = useMemo(() => {
		const unreadReportCount = parseInt(dataUnreadReport?.getCompanySubmissionReports?.countUnreadCompanySubmissionReports || 0);
		const unreadStatementCount = parseInt(dataUnreadStatement?.getUnreadEarlyWarningStatementCount?.unreadEarlyWarningStatementCount || 0);
		const unreadMDCount = parseInt(dataUnreadMDCount?.getCountUnreadNotifications || 0);
		return unreadReportCount + unreadStatementCount + unreadMDCount;
	}, [dataUnreadReport, dataUnreadStatement, dataUnreadMDCount]);

	function load() {
		loadCountUnreadReports();
		loadCountUnreadStatements();
		loadMDCount({ variables: { type: 'COMPANY_SUBMISSION_MDD_REPORT' } });
	}

	return (
		<>
			{parseInt(count) > 0 && (
				<>
					<Badge fontSize="x-large" zIndex="99" top="2px" right="2px" position="absolute" colorScheme="red">
						{parseInt(count)}
					</Badge>
				</>
			)}
		</>
	);
}

export default CompanySubmissionReportBadge;
